import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {EditorTextModalDialogData} from "./types/editor-text-modal.types";
import {RecordData, RecordUpdateRequestParams} from "../../../types/records-table.types";
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatInput} from "@angular/material/input";
import {editorTextModalName} from "./configs/editor-text-config";

@Component({
  selector: 'app-editor-text-modal',
  imports: [
    FormsModule,
    MatLabel,
    MatFormField,
    BaseModalComponent,
    MatButton,
    CdkTextareaAutosize,
    MatInput
  ],
  templateUrl: './editor-text-modal.component.html',
  styleUrl: './editor-text-modal.component.scss'
})
export class EditorTextModalComponent extends BaseModalComponent {
  public editorTextDialogData = inject<EditorTextModalDialogData>(MAT_DIALOG_DATA);

  private isEditModeActiveParent: boolean = false;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(editorTextModalName);
    this.isEditModeActiveParent = this.isEditModeActive;
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(editorTextModalName);
    this.editModeService.setEditMode(this.isEditModeActiveParent);
  }

  public async handleValueChange(): Promise<void> {
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: this.editorTextDialogData.path,
      recordId: this.editorTextDialogData.recordId,
      fieldName: this.editorTextDialogData.key,
      value: this.editorTextDialogData.content
    };

    await this.updatedRecordField<RecordData>(recordUpdateRequestParams)
      .then(() => this.dialogRef.close(this.editorTextDialogData.content));
  }
}
